export const DS_FILE_ITEM_CLASSES = {
  Root: "ds-file-item",
  Clickable: "ds-file-item--clickable",
  ClickTarget: "ds-file-item__click-target",
  Thumbnail: "ds-file-item__thumbnail",
  Content: "ds-file-item__content",
  FileName: "ds-file-item__file-name",
  Details: "ds-file-item__details",
  Detail: "ds-file-item__detail",
  Author: "ds-file-item__author",
  Actions: "ds-file-item__actions",
  Error: "ds-file-item__error",
  Progress: "ds-file-item__progress",
} as const;
